import { cn } from "@/shared/lib";

import type { OptionNoteView } from "./useOptionNote";
import type { OptionView } from "./useOptionView";
import { AssetImage } from "./AssetImage";

type OptionContentProps = {
  view: OptionView;
  // Пометка после ответа («рывок · 46 %», «не защита») — вместо цены и ветки.
  extra?: OptionNoteView | null;
  size?: number;
};

const EXTRA_TONE = {
  good: cn("text-good"),
  muted: cn("text-muted"),
  bad: cn("text-bad"),
} as const;

// Иконка, название и подпись варианта внутри `OptionButton`.
export const OptionContent = ({ view, extra = null, size = 48 }: OptionContentProps) => (
  <>
    {view.asset !== null && <AssetImage asset={view.asset} size={size} inOption />}
    <span className="flex min-w-0 flex-col">
      <span className="font-semibold">{view.name}</span>
      {extra !== null ? (
        <span className={cn("text-xs", EXTRA_TONE[extra.tone])}>{extra.text}</span>
      ) : (
        view.note !== null && <span className="text-xs text-subtle">{view.note}</span>
      )}
    </span>
  </>
);
